module.exports = __webpack_public_path__ + "static/img/pingjieshen6.012118ec.png";